<template>
  <div id="display_map" class="map-wrap bg-deep-blue">
    <div id="container"/>
    <div class="search-wrap">
      <div class="bg-white p-2 mt-3" style="box-shadow: 1px 1px 5px rgba(0,0,0,0.2)">
        <p class="text-left mb-1 h6">指定范围</p>
        <div class="d-center-between">
          <input type="text" placeholder="请输入地标名称/地址" id="pointName" class="form-control w-50">
          <select class="form-control w-30 ml-3 mr-3" v-model="pointScoped">
            <option v-for="(disItem,index) in scopeDistance" :value="disItem.value" :key="index">{{disItem.name}}
            </option>
          </select>
          <el-button type="primary" size="small" class="w-20" @click="getBasicInfo()">搜索</el-button>
        </div>
      </div>
      <div class="bg-white p-3 text-left mt-4" style="box-shadow: 1px 1px 5px rgba(0,0,0,0.2)">
        <router-link :to='typeInfo.pageTo' class="text-login h6">返回{{typeInfo.cn}}列表</router-link>
        <!--酒店查询条件-->
        <div class="border d-flex justify-content-between bg-light text-center mt-2 mb-2 position-relative">
          <div class="w-50 pt-2 pb-2">
            <span class="condition h6" @click="chooseCity">{{city.id?city.title:'城市'}}<i
              class="iconfont">&#xe749;</i></span>
          </div>
          <div class="w-50 pt-2 pb-2 border-left border-right" >
            <span class="condition h6" @click="chooseStar">{{star.id?star.name:'酒店星级'}}<i class="iconfont">&#xe749;</i></span>
          </div>
          <!-- <div class="w-50 pt-2 pb-2">
            <span class="condition h6" @click="choosePrice">{{price.id?price.name:'价格范围'}}<i
              class="iconfont">&#xe749;</i></span></div> -->
          <!--条件展示面板-->
          <div class="condition-choose p-2" v-show="setCityFlag || setStarFlag || setPriceFlag">
            <choose-city @setCity="setCity" v-show="setCityFlag" id="city-select" />
            <choose-star @setStar="setStar" v-show="setStarFlag"/>
            <choose-price @setPrice="setPrice" v-show="setPriceFlag"/>
          </div>
        </div>
        <!--酒店列表-->
        <div id="item_container">
          <el-scrollbar style="height:100%;">
            <div v-for="(hotelItem,index) in MapBasicInfo" class="hotel-item" :id="'hotel_'+hotelItem.id"
                 @click="locateHotel(hotelItem)"  :class="{active:hotelIndex===hotelItem.id}" :key="index">
              <template v-for="(img,index) in hotelItem.pic.split(',')">
                <img v-lazy="ImgPreUrl+img" alt="" width="70" height="70" :key="index" v-if="index==0">
              </template>
              <div class="ml-2 mb-2 w-100 pr-3">
                <div class="align-items-center name  mb-1">
                  <p class=" font-weight-bold  mb-1">{{hotelItem.title}}</p>
                  <span class=" mb-1">{{hotelItem.star | formatVar('HotelStar')}}</span>
                </div>
                <div class="mb-2 h7 hsp">{{ parseAddress(hotelItem) }}
                </div>
                <div class=" align-items-center h7">
                  <div class="flex-column">
                    <div class="mb-2 text-muted align-hsp" v-show="typeInfo.en!=='scenic'">
                      <span>客房数量：{{hotelItem.room_count}}</span>
                       <span>会议室数量：{{hotelItem.meeting_count}}</span>
                    </div>
                    <div class="mb-1 text-muted align-liqs" v-show="typeInfo.en!=='scenic'">
                      <!-- <span class="sonts">&yen;<span class="text-danger ml-1 mr-1">{{(userInfo.type === 2 ? hotelItem.room_price : hotelItem.room_price) || '0.00'}}</span>元</span> -->
                      <!-- <el-button type="primary" size="mini" class="ml-auto" @click="bookHotel(hotelItem)">去询价</el-button> -->
                    </div>
                    <!-- <div class="mb-1 text-muted" v-show="typeInfo.en==='scenic'">
                      <span class="text-danger" style="font-size: 12px;">&yen;<span style="font-size: 18px;">{{hotelItem.price}}</span></span>
                    </div> -->
                  </div>
                </div>        
              </div>
            </div>
            <div v-if="MapBasicInfo.length <= 0" class="text-center mt-5 h6">
              <i class="iconfont mr-2 h6">&#xe61e;</i>未查询到相关{{typeInfo.cn}}
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <!--右侧tab栏-->
    <right-tab-bar></right-tab-bar>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters,mapMutations} from 'vuex'
  import ChooseCity from '../IndexComps/MapSearch/ChooseCity'
  import ChooseStar from '../IndexComps/MapSearch/ChooseStar'
  import ChoosePrice from '../IndexComps/MapSearch/ChoosePrice'
  import RightTabBar from '@/components/PublicComp/RightTabBar.vue';   //右侧tab栏
  import provinces from '@/assets/utils/provinces'                     //省份信息
  export default {
    name: 'MapSearch',
    data() {
      return {
        scopeDistance: [{value: '', name: '距离范围'}, {value: '1', name: '1.5km'}, {value: '2', name: '3km'}, {value: '3',name: '5km'}, {value: '4', name: '10km'}],
        map: '',                                                                           //百度地图对象
        pointScoped: '',                                                                   //距离范围
        lng_lat: '',                                                                       //查询地标位置经纬度
        hotelIndex: '',                                                                    //左侧酒店active样式激活标识
        city: {},
        star: {},
        price: {},
        setStarFlag: false,
        setPriceFlag: false,
        setCityFlag: false,
        backUp: '',
        currentMarker: null, // 保存当前打开的 marker
        currentInfoWindow: null, // 新增这个
      }
    },
    components: {ChooseCity, ChooseStar, ChoosePrice,RightTabBar},
    computed: {
      ...mapState(['MapBasicInfo','inquiryList']),
      ...mapGetters(['userInfo']),
      typeInfo() {
        return {en: 'homestay', cn: '酒店', type: '5',link:'homestayDetail', pageTo:'/index/index_hotel'};
        let url = this.$route.fullPath.split('/')[2];
        if (url === 'index_homestay') return {en: 'homestay', cn: '酒店', type: '5',link:'homestayDetail', pageTo:'/index/index_hotel'};
        if (url === 'index_hotel') return {en: 'hotel', cn: '酒店', type: '3' ,link:'hotelDetail', pageTo:'/index/index_hotel'};
        if (url === 'index_scenic') return {en: 'scenic', cn: '景区', type: '6' ,link:'scenicDetail', pageTo:'/index/index_scenic'};
        return '';
      },
    },
    watch:{
      '$route': 'initMap',
    },
    mounted() {
      this.initMap();
      $(() => {
        /*设置百度地图高度*/
        $('#container').height(document.documentElement.clientHeight - 80 + 'px');
        /*设置地图搜索组件高度*/
        $('#item_container').height(document.documentElement.clientHeight / 2 + 'px');
      })
    },
    methods: {
      ...mapMutations(['UPDATEINQUIRYLISTINFO']),
      ...mapActions(['GetMapInfo', 'GetCityList']),
      //获取基本的地图显示信息
       async getBasicInfo(southWest,northEast) {
        let searchAddress = $('#pointName').val();
        //当搜索地址名不存在时，初始化经纬度条件
        if (!searchAddress) {
          this.pointScoped = '';
          this.lng_lat = '';
        }
        if (this.lng_lat) this.pointScoped = this.pointScoped ? this.pointScoped : '2';
        await this.GetMapInfo({
          data: {
            lon_lat: this.lng_lat,
            distance: this.pointScoped,
            city: this.city.id,
            star: this.star.id,
            price_type: this.price.id,
            southWest,
            northEast
          },
          type: this.typeInfo.type,
        });
        this.map.clearOverlays();                     //清除上一次的标记
        if (this.MapBasicInfo.length > 0) {
          let point = new BMap.Point(this.MapBasicInfo[0].longitude,this.MapBasicInfo[0].latitude);
          this.map.centerAndZoom(point);              //重新设置地图中心点(Point类型)
          if (this.pointScoped) {
            let pointScoped = new BMap.Point(this.lng_lat.split(',')[0],this.lng_lat.split(',')[1]);    // 创建点坐标
            this.map.panTo(pointScoped);             //移动到酒店在地图上的位置
            let circle = new BMap.Circle(pointScoped,this.pointScoped * 3000,{strokeColor:'blue', strokeWeight:2, strokeOpacity:0.5}); //创建圆
            this.map.addOverlay(circle);            //增加圆
          }
          // 批量添加marker
          for (let i = 0; i < this.MapBasicInfo.length; i++) {
            let point = new BMap.Point(this.MapBasicInfo[i].longitude, this.MapBasicInfo[i].latitude);
            this.addMarker(point, this.MapBasicInfo[i]);
          }
        }
      },
      /*返回标注的信息窗口dom*/
      startLabel(star){
        let ret = ''

        this.$GVAR.HotelStar.some(item=>{
          if(item.id==star){
            ret = item.name
          }   
        })
        return ret
        
      },
      //初始化百度地图组件
      initMap() {
        this.map = new BMap.Map('container');                 // 创建地图实例
        let point = new BMap.Point(120.10, 30.45);            // 创建点坐标
        this.map.centerAndZoom(point, 12);                    // 初始化地图，设置中心点坐标和地图级别
        this.map.enableScrollWheelZoom(true);                //开启鼠标滚轮缩放
        this.map.addControl(new BMap.NavigationControl({anchor : BMAP_ANCHOR_TOP_RIGHT}));       //平移缩放控件
        this.map.addControl(new BMap.ScaleControl({anchor: BMAP_ANCHOR_BOTTOM_RIGHT}));        //比例尺控件
        //建立一个自动完成的对象
        let ac = new BMap.Autocomplete({'input': 'pointName', 'location': this.map});
        let myValue;
        ac.addEventListener('onconfirm', e => {    //鼠标点击下拉列表后的事件
          let _value = e.item.value;
          myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
          let local = new BMap.LocalSearch(this.map, { //智能搜索
            onSearchComplete: () => {
              let localData = local.getResults().getPoi(0).point;    //获取第一个智能搜索的结果
              this.lng_lat = localData.lng + ',' + localData.lat;
            }
          });
          local.search(myValue);
        });
        /*注册滚轮缩放事件和拖拽地图事件*/
        let mapScope = () => {
          let southWest = this.map.getBounds().getSouthWest().lng + ',' + this.map.getBounds().getSouthWest().lat; //可视区域左下角
          let northEast = this.map.getBounds().getNorthEast().lng + ',' + this.map.getBounds().getNorthEast().lat; //可视区域右上角
          this.getBasicInfo(southWest,northEast);
        };
        this.map.addEventListener('zoomend', evt => { mapScope(); });
        this.map.addEventListener('dragend', evt => { mapScope(); });
        //初始化完成后调用接口查询酒店并渲染
        this.getBasicInfo();
      },
      //在地图中添加覆盖物
      addMarker(point, obj) {
                // 1. 先算好是否存在
        let isExist = this.isIdExist(this.inquiryList, obj.id,'id'),myIconPng;
        if(isExist){
          myIconPng = require('../../../../public/images/public/icon-active.png');
        }else{
          myIconPng = require('../../../../public/images/public/icon.png');
        }
        let myIcon = new BMap.Icon(myIconPng, new BMap.Size(32, 32));
        // 创建标注对象并添加到地图
        let marker = new BMap.Marker(point, {icon: myIcon});
          // 关键：保存当前 marker
       
        // 创建信息窗口对象
        let infoWindow = this.createInfoDom(obj);
        marker.addEventListener('click', () => {
          this.map.panTo(point);                           //移动到酒店在地图上的位置
          this.map.openInfoWindow(infoWindow, point);      // 打开信息窗口
            // 保存当前打开的 InfoWindow
          this.currentMarker = marker;
          this.currentInfoWindow = infoWindow;
        //将左侧酒店滚动到第一个显示
          let hotel = '#hotel_' + obj.id;
          this.hotelIndex = obj.id;
          let firstHotelDom = '#hotel_' + this.MapBasicInfo[0].id;
          let movePx = $(hotel).offset().top - $(firstHotelDom).offset().top;
          $('.el-scrollbar__wrap').animate({scrollTop:movePx},800);
        });
        this.map.addOverlay(marker);
      },
      /*点击左侧列表酒店，在地图中定位酒店*/
      locateHotel(hotelItem) {
        this.hotelIndex = hotelItem.id;
        let point = new BMap.Point(hotelItem.longitude, hotelItem.latitude);
        this.map.panTo(point);          //移动到酒店在地图上的位置
        this.addMarker(point, hotelItem);
        // 创建信息窗口对象
        let infoWindow = this.createInfoDom(hotelItem);
        this.map.openInfoWindow(infoWindow, point);      // 打开信息窗口
        this.addMarker(point,hotelItem);
      },
      createInfoDom(item) {
        let title = this.$GFUN.formatString(8,item.title);
        // 1. 先算好是否存在
        let isExist = this.isIdExist(this.inquiryList, item.id,'id');
        item.isExist=isExist;                         //赋值状态值
        let opts = {
          width: 250,       // 信息窗口宽度
          height: 115,      // 信息窗口高度
          // 信息窗口标题
          title: `<div class="d-flex align-items-center">
                    <span class="map-info-title" data-id="${item.id}" onclick="linkToHotelDetail(this)">${title}</span>
                    <img src="/images/grade/${item.level_pic}" alt="">
                  </div>`
        };
        let hotelAddress = item.city_name + item.district_name + item.address;
        let star=this.startLabel(item.star);
        let detailContent = '';
        if (this.typeInfo.en !== 'scenic') detailContent = `<div>客房数量：${item.room_count}</div><div>会议厅数量：${item.meeting_count}</div>`;
        else detailContent = `可预订团队票和散客票`;
        let infoContent = `<div class="text-muted h6">
                                <div class="align-items-center namnps  mb-1">
                                  <p class=" font-weight-bold  mb-1 "data-id="${item.id}" onclick="linkToHotelDetail(this)">${item.title}</p>
                                  <span class="mb-1 yasq">${star}</span>
                                </div>
                                <div class="d-flex justify-content-between align-items-center liqs mb-2">
                                  ${detailContent}
                                </div>
                                <div class='liqs'>
                                  <div onclick="orderPost(this)" data-value='${JSON.stringify(item)}'   class=" ${isExist ? 'disableds' : ''}"
                                  style="border: 1px solid #0698ff;border-radius: 5%; padding: 6px 12px; color: #0698ff">${isExist ? '取消询价' : '加入询价'}</div>
                                  <div onclick="confirmation(this)" data-value='${JSON.stringify(item)}'  class="ml-1 text-white"
                                  style="border: 1px solid #0698ff;background-color: #0698ff;border-radius: 5%; padding: 6px 12px;border: none;">确认单</div>
                                </div>
                            </div>`;
                            //             <span>&yen;<span class="text-danger ml-2 mr-1">${item.room_price || '0.00'}</span>元</span>
        //添加跳转事件,为预订按钮添加事件处理
        window.linkToHotelDetail = (itemDom) => {
          let id = $(itemDom).data('id');
          let routeData = this.$router.resolve({
            name: this.typeInfo.link,
            params:{id,}
          });
          window.open(routeData.href, '_blank');   //跳转到一个新的页面
        };
        // 添加跳转事件,为预订按钮添加事件处理
        window.orderPost = (itemDom) => {
          let item=$(itemDom).data('value');
          //添加或删除询价列表
          if(item.isExist){
            //删除
            this.UPDATEINQUIRYLISTINFO({infoList:item,modify:'deletes'});
          }else{
            //添加
            this.UPDATEINQUIRYLISTINFO({infoList:item,modify:'add'});
          }
          // ==============================================
          // 更新地图标记点
          // ==============================================
          if(this.currentMarker){
            let newInfoWin = this.createInfoDom(item);
            this.map.openInfoWindow(newInfoWin, this.currentMarker.getPosition());

            if (this.currentMarker) {
              let activeIcon = new BMap.Icon(
                require(`../../../../public/images/public/${item.isExist ? 'icon-active.png' : 'icon.png'}`), // 已添加图标
                new BMap.Size(32, 32)
              );
              this.currentMarker.setIcon(activeIcon); // 直接改图标，不影响地图位置
            }
          }

        };
        //确认单按钮点击事件处理
        window.confirmation = (itemDom) => {
          this.$message.error('功能正在开发中')
        };
        return new BMap.InfoWindow(infoContent, i);
      },
      // 判断 id 是否存在
      isIdExist(arr, id, key) {
        return arr.some(item => item[key] === id)
      },
      /*选择城市面板*/
      chooseCity() {
        this.setCityFlag = !this.setCityFlag;
        // if (this.citysArr.length > 0) {
          this.setPriceFlag = false;
          this.setStarFlag = false;
        // }
        this.GetCityList({});
      },
      /*打开选择酒店星级面板*/
      chooseStar() {
        this.setCityFlag = false;
        this.setPriceFlag = false;
        this.setStarFlag = !this.setStarFlag;
      },
      /*打开选择价格范围面板*/
      choosePrice() {
        this.setCityFlag = false;
        this.setStarFlag = false;
        this.setPriceFlag = !this.setPriceFlag;
      },
      //设置城市
      setCity(cityItem) {
        this.city = cityItem;
        let point = new BMap.Point(cityItem.longitude, cityItem.latitude);
        this.map.panTo(point);          //移动到酒店在地图上的位置
        console.log(cityItem);
        this.getBasicInfo();
        this.setCityFlag = false;
      },
      /*设置星级*/
      setStar(starItem) {
        this.star = starItem;
        this.getBasicInfo();
        this.setStarFlag = false;
      },
      //设置价格区间
      setPrice(priceItem) {
        this.price = priceItem;
        this.getBasicInfo();
        this.setPriceFlag = false;
      },
      //获取本地地址信息
      parseAddress(res){
        let city = provinces.find(item => item.id == res.city);
        let district = provinces.find(item => item.id == res.district);
        return `${city.title}${district.title}${res.address}`;
      },
      //向酒店发布定向订单
      bookHotel(hotelInfo) {
        if (this.userInfo.type !== 2)
          this.$alert('您不是采购商用户，无法预订该酒店', '提示', {
            confirmButtonText: '确定',
            center: true
          });
        else {
          if (this.typeInfo.en === 'hotel') {
            let queryData = {
              type: '住宿订单',
              hotel: hotelInfo.id,
              hotelName: hotelInfo.title,
              province: hotelInfo.province,
              provinceName: hotelInfo.provinceName,
              city: hotelInfo.city,
              cityName: hotelInfo.cityName,
              district: hotelInfo.district,
              districtName: hotelInfo.districtName,
              star: hotelInfo.star,
            };
            this.$router.push({name: 'OrderPost', query: queryData});
          } else if (this.typeInfo.en === 'homestay') this.$router.push('/index_homestay/homestay_detail/' + hotelInfo.id);
          else if (this.typeInfo.en === 'scenic') this.$router.push('/index_scenic/scenic_detail/' + hotelInfo.id)
        }
      },
    }
  }
 </script>

<style lang="scss" scoped>
  .sonts{
    line-height: 32px;
  }
  .sonts>span{
    font-weight: bold;
    font-size: 16px;
  }
  .align-hsp{
    color: #666;
    font-size: 12px;
    
  }
  .align-hsp{
    display: flex;
    justify-content:space-between;
    color: #999;
  }
  .name{
    font-size: 15px;
  }
  .name p{
    float: left;
    margin-right: 6px;
  }
  .name span{
    font-weight: bold;
    color: var(--smtc-color-primary); 
    min-width: 60px; 
    display: inline-block;
  }

  .form-control {
    display: block;
    height: 30px;
    font-size: 14px;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .map-wrap {
    position: relative;
    .search-wrap {
      position: absolute;
      top: 20px;
      left: 20px;
      width: 28%;
      min-width: 342px;
      max-width: 400px;
      margin-bottom: 50px;
      .condition {
        cursor: pointer;
        &:hover {
          color: cornflowerblue;
        }
      }
      .hotel-item {
        display: flex;
        align-items: flex-start;
        border-bottom: 1px solid #ddd;
        padding: 1rem 0;
        cursor: pointer;
        &:hover {
          background: #eee;
        }
      }
      .active {
        background: #eee;
      }
      .condition-choose {
        width: 95%;
        border: 1px solid #ddd;
        background: #fff;
        box-shadow: 0 0 2px 2px #eee;
        z-index: 66;
        padding-right: 30px;
        text-align: left;
        position: absolute;
        top: 30px;
        left: -1px;
      }
    }
  }
</style>
<style>
  .liqs{
    display: flex;
    justify-content:end;
    color: #999;
    cursor: pointer;
  }
  .disableds{
      background-color: #dddd;
      border: 1px #ddd solid !important;
      color: #b2b2b2 !important;
  }
  .namnps{
    font-size: 15px;
        cursor: pointer;
  }
  .namnps p{
    float: left;
    margin-right: 6px;
    color: #333;
  }
  .namnps span{
    color: #999;
    min-width: 60px;
    font-size: 15px; 
    display: inline-block;
  }
</style>